import React from 'react';
import { createPortal } from 'react-dom';
import { X, UserCog } from 'lucide-react';
import PainelNegociacaoCobranca from './PainelNegociacaoCobranca';
import { propsFundoModal } from '../lib/backdropModal';

interface ClienteCobrancaModalProps {
    isOpen: boolean;
    onClose: () => void;
    cpfCnpjCliente: string | null;
    clienteNome?: string | null;
}

/**
 * "Janela de gerenciamento completo" de um cliente em cobrança — mesmo
 * PainelNegociacaoCobranca usado dentro de CobrancaEnviadaModal (Financeiro),
 * só que como modal próprio. Porta de entrada a partir da Central de
 * Inadimplência (clique na linha de um cliente).
 */
const ClienteCobrancaModal: React.FC<ClienteCobrancaModalProps> = ({ isOpen, onClose, cpfCnpjCliente, clienteNome }) => {
    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in p-4" {...propsFundoModal(() => onClose())}>
            <div className="bg-white dark:bg-gray-800/95 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto flex flex-col border border-gray-100 dark:border-gray-700" onClick={e => e.stopPropagation()}>
                <div className="p-6 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center gap-4 bg-primary/5 dark:bg-primary/10 sticky top-0 z-10">
                    <div className="flex items-center gap-3">
                        <div className="w-11 h-11 rounded-xl bg-primary/10 dark:bg-primary/20 text-primary flex items-center justify-center shrink-0">
                            <UserCog size={22} />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Gerenciar Cobrança</h2>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{clienteNome || 'Cliente'}</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors text-gray-400 shrink-0">
                        <X size={22} />
                    </button>
                </div>

                <div className="p-6">
                    {cpfCnpjCliente ? (
                        <PainelNegociacaoCobranca isOpen={isOpen} cpfCnpjCliente={cpfCnpjCliente} clienteNome={clienteNome} />
                    ) : (
                        <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">
                            Não foi possível identificar o CPF/CNPJ deste cliente nas faturas em aberto — cadastre o documento na Unidade Consumidora para habilitar o gerenciamento de cobrança.
                        </p>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ClienteCobrancaModal;
